// API URL configuration
export const API_URL = '/api';  // Both prod and dev will use relative URLs 